<template>
  <div id="Admin">

    <p v-if="!ready">{{ $t('message.loading') }}</p>

    <section
      v-if="ready"
      style="padding: 10px;font-size: 13px;">
      <p>User Logs ({{ userlogs.length }})</p>
      <table
        class="table"
        width="100%">
        <thead>
          <tr>
            <th style="font-size: 13px;">Request</th>
            <th style="font-size: 13px;">OS</th>
            <th style="font-size: 13px;">Browser</th>
            <th style="font-size: 13px;">Device</th>
            <th style="font-size: 13px;">Created</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in userlogs">
            <td>
              <span class="badge badge-secondary">{{ item.request.type }}</span>
              {{ item.request.url }}
            </td>
            <td>{{ item.system.os }}</td>
            <td>{{ item.system.browser }}</td>
            <td>{{ item.system.device }}</td>
            <td>{{ getDateTime(item.created_at) }}</td>
          </tr>
        </tbody>
      </table>
    </section>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AdminUserLog',
  data () {
    return {
      ready: false,
      sort: '',
    }
  },
  computed: {
    ...mapGetters({
      userlogs: 'getUserLogs',
    }),
  },
  methods: {
    ...mapActions([

    ]),
  },
  watch: {
    ready: function (after) {
      if (after == true) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
  },
  beforeMount: function () {
    // set section
    this.$store.dispatch('setSection', 'admin')
  },
  created: async function () {
    await this.$store.dispatch('getUserLogs', {
      user_id: this.$route.query.user_id,
    })
    // set ready
    this.ready = true
  },
}
</script>



// WEBPACK FOOTER //
// src/components/admin/UserLog.vue